"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./default"), exports);
tslib_1.__exportStar(require("./group"), exports);
tslib_1.__exportStar(require("./standard"), exports);
exports.DefaultTemplateBundle = [
    function (types) { return undefined; },
];
